/* eslint-disable max-len */
import { OV_EMS_CDN } from '../../config/theme';
var alt = 'A photo of four friends hiking through the wetlands';
var imageRoot = "".concat(OV_EMS_CDN, "media/pages/");
var props = {
  blurb: 'Sign-up for text messages to stay in the loop on new product drops, early access, exclusive offers and more. See our <a href="https://www.outdoorvoices.com/terms" target="_blank" rel="noopener noreferrer">terms and conditions</a>.',
  disclaimerPreSubmit: 'By submitting your phone number, you agree to receive recurring automated marketing text messages. Consent is not a condition of purchase. Reply HELP for help and STOP to cancel. Message frequency varies by account. Message and sate rates may apply. See <a href="/privacy-policy">Privacy Policy</a> and <a href="https://assets.conciergeteam.co/clients/outdoorvoices/sms_terms.html" target="_blank" rel="noopener noreferrer">SMS Terms</a>.',
  disclaimerPostSubmit: 'See <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://assets.conciergeteam.co/clients/outdoorvoices/sms_terms.html" target="_blank" rel="noopener noreferrer">SMS Terms</a>.',
  imageDesktop: {
    alt: alt,
    src: "".concat(imageRoot, "sign-up-desktop.jpg")
  },
  imageMobile: {
    alt: alt,
    src: "".concat(imageRoot, "sign-up-mobile.jpg")
  },
  success: {
    message: 'Look out for a text message from us soon.',
    title: 'Game On.'
  },
  title: 'You’ve got digits, we’ve got points.',
  utmCampaign: 'loyalty-signup'
};
export default props;